import PropTypes from 'prop-types';
import { BroadcastCard } from 'components/Broadcast/card';
import Loader from 'components/Loader';

export default function BroadcastCards({
  term = '',
  typeFilter = '',
  channels = [],
  loading = true,
  defaultFilter = '',
}) {
  const getFilteredChannels = (list, filterText, searchText = '') => {
    searchText = searchText.toLowerCase();
    if (filterText === defaultFilter) {
      return searchText
        ? list.filter((item) => item.name.toLowerCase().includes(searchText))
        : list;
    }

    const selectedList = list.filter((item) => item.type === filterText);

    return searchText
      ? selectedList.filter((item) =>
          item.name.toLowerCase().includes(searchText),
        )
      : selectedList;
  };

  if (loading) {
    return <Loader upload_message={'loading'} full_height />;
  } else {
    const filteredChannels = getFilteredChannels(channels, typeFilter, term);

    return filteredChannels.length ? (
      <div className="mt-6 grid gap-5 grid-cols-1 md:grid-cols-3 lg:grid-cols-5">
        {filteredChannels.map((broadcast) => (
          <BroadcastCard broadcast={broadcast} key={broadcast.id} />
        ))}
      </div>
    ) : (
      <>
        <p class="max-w-lg text-3xl leading-loose text-gray-900 dark">
          No match found
        </p>
      </>
    );
  }
}

BroadcastCard.propTypes = {
  typeFilter: PropTypes.arrayOf(String),
};
